import { gql } from 'graphql-request'

export const SELF_PAYMENT_OBLIGATIONS_DETAILS = gql`
  fragment SelfPaymentObligationsDetails on SelfPaymentObligation {
    tunniste
    maksurytmi
    aloituspvm
    lopetuspvm
    viitelajiKoodi
    viitelaji
    maksujaksonPituus
    elaskuSumma
    viitetulostus
  }
`
export const SETTLEMENT_OBLIGATIONS_DETAILS = gql`
  fragment SettlementObligationsDetails on SettlementObligation {
    tunniste
    tilitystapaKoodi
    tilitystapa
    tilittajanTyonantajatunnus
    tilittajanNimi
    selvittajanTyonantajatunnus
    selvittajanNimi
    aloituspvm
    lopetuspvm
    viitetulostus
  }
`

export const TRANSLATION_VALUES = gql`
  fragment TranslationValues on Translations {
    fi {
      display
      value
    }
    en {
      display
      value
    }
    sv {
      display
      value
    }
  }
`
